import { css } from 'styled-components'

type BadgeSize = 'small' | 'medium'

interface IBadgeSizeStyles {
  fontSize: number
  paddingY: number
  paddingX: number
}

const BADGE_SIZE_STYLES: Record<BadgeSize, IBadgeSizeStyles> = {
  small: { fontSize: 12, paddingY: 2, paddingX: 8 },
  medium: { fontSize: 14, paddingY: 4, paddingX: 12 },
}

export interface IBaseBadgeProps {
  size?: BadgeSize
}

const getSizeStyles = ({ size = 'medium' }: IBaseBadgeProps) =>
  BADGE_SIZE_STYLES[size]

export const BaseBadgeStyles = css<IBaseBadgeProps>`
  font-size: ${(props) => getSizeStyles(props).fontSize}px;

  line-height: ${(props) => props.theme.typography.pxToRem(16)};
  font-weight: ${(props) => props.theme.typography.fontWeightMedium};
  font-family: ${(props) => props.theme.fontFamily.body};
  padding: ${(props) =>
      props.theme.typography.pxToRem(getSizeStyles(props).paddingY)}
    ${(props) => props.theme.typography.pxToRem(getSizeStyles(props).paddingX)};

  display: inline-flex;
  align-items: center;

  border-radius: ${(props) => props.theme.typography.pxToRem(4)};

  text-wrap: nowrap;
`
